import { projectNameUpperCase } from '../config';

const skMessages = {
  sk: {
    app: {
      cart: 'Košík',
      units: 'ks',
      language: 'Voľba jazyka',
      activateUser: 'Aktivovať používateľa',
      addToCart: 'Vloženie do košíka',
      addToFavorites: 'Pridať do obľúbených',
      removeFromFavorites: 'Odstrániť z obľúbených',
      addUser: 'Pridať používateľa',
      cartInProcess: {
        heading: 'Už máte rozpracovaný košík',
        content: 'Máte naplnený košík rozpracovanou objednávkou.',
      },
      changePage: 'Zmeniť stránku',
      changePassword: 'Zmena hesla',
      userStatusUpdateResponse: {
        activation: 'Používateľ bol aktivovaný',
        deactivation: 'Používateľ bol deaktivovaný',
      },
      deactivateUser: 'Deaktivovať používateľa',
      globalSearchPlaceholder: 'Hľadať v katalógu',
      hideGlobalSearchPlaceholder: 'Skryť vyhľadávanie',
      go: 'Prejsť',
      haveAQuestion: 'Mám otázku',
      home: 'Domov',
      initialSetup: 'Úvodné ustanovenia...',
      itemsPerPage: 'Položiek na stránku',
      logout: 'Odhlásiť sa',
      logoutConfirmation: 'Naozaj sa chcete odhlásiť?',
      pickDeliveryPlace: {
        helperText: 'Vyberte prevádzku, do ktorej bude objednávka doručená',
        label: 'Miesto doručenia',
        requiredError: 'Vyberte prosím prevádzku',
      },
      pickShipping: {
        helperText: 'Vyberte spôsob doručenia, ktorý sa má použiť na doručenie objednávky',
        label: 'Spôsob doručenia',
        requiredError: 'Vyberte prosím spôsob doručenia',
      },
      pickPayment: {
        helperText: 'Vyberte platobnú metódu, ktorá sa má použiť na platbu objednávky',
        shippingSelectionRequired: 'Pred voľbou platobnej metódy je potrebné vybrať spôsob doručenia',
        label: 'Platobná metóda',
        requiredError: 'Vyberte prosím platobnú metódu',
      },
      portal: 'portál',
      products: {
        canceled: ' - Produkt vyradený',
        stockQuantityInfo: {
          notOnStock: 'nie je na sklade',
          notOnStockKnownWhenExpected: 'očakávaný dátum naskladnenia {timing}',
          onRequest: 'Na dopyt',
          onStock: 'na sklade',
          pcs: '{qty, plural, one {{qty} kus na sklade} few {{qty} kusy na sklade} other {{qty} kusov na sklade}}',
          pcs50to100: '50 až 100 kusov na sklade',
          pcs100to500: '100 až 500 kusov na sklade',
          pcsOver500: 'Viac ako 500 kusov na sklade',
        },
        showMore: 'Zobraziť viac',
        showLess: 'Zobraziť menej',
      },
      productQuestion: {
        yourQuestion: 'Vaša otázka k produktu',
        successResponse: 'Vaša otázka k produktu bola úspešne odoslaná',
        errorResponse: 'Vašu otázku k produktu sa nepodarilo odoslať',
      },
      replace: 'Nahradiť',
      termsAndConditions: 'Všeobecné obchodné podmienky',
      termsAndConditionsPHT: `Všeobecné obchodné podmienky spoločnosti ${projectNameUpperCase}`,
      toHome: 'Na domovskú stránku',
      dataIsNotAvailable: 'Údaje momentálne nie sú k dispozícii',
    },
    appFooterAdvantages: {
      freeShipping: {
        label: 'Doprava zadarmo od 120 €',
        description:
          'Pri objednávke nad 120 € získate dopravu ZADARMO. Pre nižšie objednávky vám bude účtovaný poplatok 4 € bez DPH.',
      },
      productsInStock: {
        label: 'Produkty máme skladom',
        description:
          'Aktuálne stavy zásob, promoakcie a ďalšie užitočné informácie v PC i v mobile. Objednávajte si z pohodlia vášho domova, či salónu, kedy chcete.',
      },
      officialDistribution: {
        label: 'Oficiálna distribúcia pre ČR a SR',
        description:
          'MAX.CARE je výhradný exkluzívny partner značky Schwarzkopf Professional (Spoločnosť Henkel) pre Českú republiku a Slovensko.',
      },
      professionalsOnly: {
        label: 'Len pre profesionálov',
        description:
          'Vstup do tohto portálu bude len pre Partnerov spoločnosti MAX.CARE s uzavretou zmluvou o spolupráci a je potrebné požiadať o registráciu.',
      },
    },
    bulkPurchase: {
      errorNotFound: 'Kód {code} sa nenašiel',
      errorCancelled: 'Kód {code} odkazuje na produkt vyradený z ponuky',
      errorNotEnough:
        'Kód {code} nie je na sklade v požadovanom množstve. Celkové množstvo na sklade: {availableQuantity}',
      validationErrorSummary: 'Neúspešných položiek: {count}',
      formatError: 'Neplatný formát',
      validationResultsTitle: 'Výsledky kontroly',
      afterFormatControl: 'Po kontrole formátu',
      controlFormat: 'Kontrola formátu',
      downloadSampleDocument: 'Stiahnuť šablónu',
      noInputData: 'Nie sú zadané vstupné údaje.',
      pageTitle: 'Hromadné vloženie',
      productsWereAdded: 'Všetky identifikované produkty boli pridané do košíka.',
      textRows: {
        helperText: `Vložte hodnoty \`KODPRODUKTU;MNOZSTVO\` alebo \`KODPRODUKTUmedzeraMNOZSTVO\`, napr. \`A03001006;9\`. Pri viac ako 1 produkte musí byť ďalší KÓD PRODUKTU na novom riadku. Môžete tiež využiť možnosť importu z Excelu pomocou kopírovania a následného vloženia stĺpcov.`,
        label: 'Textové riadky',
      },
      toCart: 'Do košíka',
      errors: {
        productNotFound: 'Produkt sa nenašiel.',
      },
    },
    cartApprovalPage: {
      noCartFound: 'Objednávka na schválenie sa nenašla alebo nemáte oprávnenie na jej schválenie.',
      areYouSureToSend: 'Naozaj chcete objednávku odoslať?',
      continueShopping: 'Pokračovať v nákupe',
      pageTitle: 'Schválenie objednávky',
      confirmText: 'Naozaj chcete objednávku odoslať na schválenie?',
    },
    cartSummaryPage: {
      cartRefresh: {
        close: 'Zavrieť',
        note: 'Skontrolujte prosím obsah košíka pred odoslaním objednávky.',
        reason: {
          noPrice: 'pri produkte sa nepodarilo zistiť cenu a bol z košíka odobraný',
          priceChanged: 'cena sa zmenila',
          quantityReduced: 'množstvo znížené podľa skladu z {from} na {to}',
          soldOut: 'produkt nie je skladom a bol z košíka odobraný',
          unavailable: 'produkt už nie je v predaji a bol z košíka odobraný',
        },
        title: 'Košík bol aktualizovaný',
      },
      cartLoyaltyPoints: {
        insufficientLoyaltyPoints: 'Nemáte dostatok vernostných bodov pre túto objednávku.',
        title: 'Nákupom získate:',
        titleSpent: 'Máte vybrané produkty za:',
        points: `{
        points, plural,
        one {1 vernostný bod} 
        few {{points} vernostné body} 
        other {{points} vernostných bodov} 
        }`,
      },
      missingDeliveryPlace: 'Na odoslanie objednávky je potrebné vybrať miesto dodania.',
      alreadyNeedToBeSentForApproval:
        'Došlo k prekročeniu limitu pobočky vplyvom ďalších súčasne vytvorených objednávok. Vaša objednávka musí byť odoslaná na schválenie.',
      cheaperProducts: `{
        possibleProducts, plural,
        one {V košíku je 1 produkt, ktorý sa dá kúpiť lacnejšie} 
        few {V košíku sú {possibleProducts} produkty, ktoré sa dajú kúpiť lacnejšie} 
        other {V košíku je {possibleProducts} produktov, ktoré sa dajú kúpiť lacnejšie} 
      }`,
      separateOrderRequired: 'Množstevnú jednotku paleta je potrebné zadať na samostatnej objednávke',
      previewBeforeOrder: 'Prehľad pred objednaním',
      leftToContactLimit: 'Zostávajúci mesačný limit',
    },
    favoriteProductsPage: {
      title: 'Obľúbené produkty',
    },
    cataloguePage: {
      title: 'Všetky produkty',
      individualPrice: 'Individuálna cena',
      item: {
        package: 'Dostupnosť',
      },
      chooseManufacturer: 'Vyberte výrobcu',
      noMatch: 'Váš výber neobsahuje žiadne položky.',
      orderBy: {
        code: 'Kód',
        name: 'Názov',
        priceAsc: 'Od najlacnejšieho',
        priceDesc: 'Od najdrahšieho',
      },
      searchPlaceholder: 'Vyhľadať',
      warningButton: {
        hideProducts: 'Skryť varianty produktu',
        showProducts: 'Zobraziť varianty produktu',
        hideCheaperProducts: 'Skryť lacnejšie varianty produktu',
        otherOptions: 'Varianty sú dostupné v detaile produktu',
        showCheaperProducts: 'Zobraziť lacnejšie varianty produktu',
      },
      moreOnProductDetail: '... ďalšie v detaile produktu',
    },
    loyaltyProgramPage: {
      title: 'Vernostný program',
      yourPoints: 'Vaše vernostné body',
      pointsPrice: 'Cena v bodoch',
      points: 'bodov',
      notEnoughPoints: 'Nedostatok bodov',
      noMatch: 'Žiadne darčeky nie sú k dispozícii.',
    },
    clickToUpload: 'Kliknite pre výber súboru',
    common: {
      detail: 'Detail',
      loading: 'Prebieha načítavanie údajov...',
      ok: 'OK',
      yourEmail: 'Váš e-mail',
      itemName: 'Názov',
      cu3Price: 'Predajná cena bez zľavy',
      items: 'položiek',
      page: 'stránka',
      email: 'E-mail',
      phone: 'Telefón',
      country: 'Krajina',
      city: 'Mesto',
      zip: 'PSČ',
      days: 'dní',
      street: 'Ulica',
      priceLevel: 'Cenová úroveň',
      paymentType: 'Forma úhrady',
      responsiblePersonName: 'Zodpovedná osoba',
      maturityPeriod: 'Splatnosť',
      region: 'Región',
      currency: 'Mena',
      hideFilter: 'Skryť filter',
      showFilter: 'Zobraziť filter',
      of: 'z',
      created: 'Vytvorené',
      search: 'Vyhľadať',
      confirmReset: 'Potvrdiť reset',
      resetCart: 'Resetovať košík',
      resetFilter: 'Resetovať filter',
      resetFilterParam: 'Zrušiť výber parametra {paramName}',
      buyForFreeDeliveryAmount: 'Nakúpte ešte za {amount} ',
      buyForFreeDeliveryRest: 'a máte dopravu zadarmo',
      youHaveFreeDelivery: 'Máte dopravu zadarmo',
      approveOrder: 'Schváliť objednávku',
      approver: 'Schvaľovateľ',
      basePriceWithoutTax: 'Základná cena bez DPH',
      basePriceWithTax: 'Základná cena s DPH',
      reccomendedPrice: 'Predajná cena bez zľavy',
      yourPrice: 'Vaša cena bez DPH',
      yourPriceWithTax: 'Vaša cena s DPH',
      buy: 'Kúpiť',
      canceled: 'Zrušené',
      code: 'Kód',
      company: 'Firma',
      createOrder: 'Vytvoriť objednávku',
      date: 'Dátum',
      deliveredQuantity: 'Dodané množstvo',
      documentNumber: 'Číslo dokumentu',
      parameterNotFound: 'Hodnota parametra sa nenašla',
      EAN: 'EAN',
      pallet: 'Na palete',
      yes: 'Áno',
      no: 'Nie',
      expiration: 'Expirácia',
      externalOrderNumber: 'Vaše číslo požiadavky',
      free: 'Zadarmo',
      listPage: {
        table: {
          columns: {
            billingAddress: 'Fakturačná adresa',
            dateOfOrder: 'Dátum objednania',
            deliveryAddress: 'Miesto dodania',
            id: 'Číslo',
            orderNumber: 'Číslo požiadavky',
            state: 'Stav',
            totalWithoutTax: 'Spolu',
            totalWithTax: 'Spolu s DPH',
          },
        },
      },
      lookup: 'Pohľadávka',
      minimumOrderQuantity: 'Minimálne objednateľné množstvo',
      name: 'Meno',
      newOrderConfirmation: 'Potvrdenie novej objednávky',
      notInStock: 'nie je na sklade',
      orderDetail: 'Detail objednávky',
      orderNumber: 'Číslo požiadavky',
      password: 'Heslo',
      passwordConfirm: 'Potvrdenie hesla',
      pricePerPiece: 'Cena/ks',
      quantity: 'Množstvo',
      regNo: 'IČO',
      rejectOrder: 'Zamietnuť objednávku',
      send: 'Odoslať',
      supplierNote: 'Poznámka pre dodávateľa',
      taxNo: 'DIČ',
      totalWithoutTaxDiscounts: 'Spolu ušetrená čiastka bez DPH',
      totalWithoutTax: 'Spolu bez DPH',
      totalWithTax: 'Spolu s DPH',
      type: 'Typ',
      username: 'Používateľské meno',
      vat: 'DPH',
      vatDMIC: 'DMIC s DPH',
      vatDMOC: 'DMOC s DPH',
      waitinForConfirmation: 'Čaká na potvrdenie',
      weight: 'Hmotnosť',
      withoutTax: 'Bez DPH',
      withoutTaxPerPc: 'bez DPH za ks',
      withTax: 'S DPH',
      withTaxPerPc: 's DPH za ks',
      unit: 'Merná j.',
    },
    creditNotes: {
      actions: {
        addNewCreditNote: 'Pridať nový dobropis',
        all: 'Všetky dobropisy',
      },
      creditNote: {
        billingAddress: {
          helperText: '',
          helperTextPreview: '',
          label: 'Fakturačná adresa',
        },
        invoiceDate: {
          helperText: '',
          helperTextPreview: '',
          label: 'Dátum vystavenia',
        },
        newEntity: 'Nový dobropis',
        number: {
          helperText: '',
          helperTextPreview: '',
          label: 'Číslo',
        },
        orderNumber: {
          helperText: '',
          helperTextPreview: '',
          label: 'Číslo požiadavky',
        },
        total: {
          helperText: '',
          helperTextPreview: '',
          label: 'Spolu',
        },
        totalWithTax: {
          helperText: '',
          helperTextPreview: '',
          label: 'Spolu s DPH',
        },
      },
      downloadCreditNote: 'Stiahnuť dobropis',
      listPage: {
        table: {
          columns: {
            invoiceDate: 'Dátum vystavenia',
          },
          filter: {
            number: 'Číslo',
          },
        },
        title: 'Dobropisy',
      },
      scoringBlog: {
        creditNoteRowsBlogPreview: {
          columns: {
            priceUnit: 'Cena/ks',
          },
          title: 'Riadky dobropisu',
        },
      },
    },
    customerProfileCreditNoteDetailPage: {
      subjectList: {
        title: 'Položky',
      },
    },
    customerProfileCreditNotesPage: {
      filter: {
        number: 'Číslo dobropisu',
      },
      notAllowedViewCreditNotes: 'Nemáte oprávnenie na prehliadanie dobropisov.',
      title: 'Dobropisy',
    },
    customerProfileDocumentsPage: {
      pageTitle: 'Dokumenty',
      title: 'Dokumenty',
    },
    customerProfileDeliveryNotesPage: {
      pageTitle: 'Dodacie listy',
      title: 'Dodacie listy',
    },
    customerProfileInvoiceDetailPage: {
      downloadInvoice: 'Stiahnuť faktúru',
      searchByInvoiceNumber: 'Vyhľadať produkty faktúry',
      subjectList: {
        title: 'Položky faktúry',
      },
    },
    customerProfileInvoicesPage: {
      filter: {
        number: 'Číslo faktúry',
      },
      notAllowedViewInvoices: 'Nemáte oprávnenie na prehliadanie faktúr.',
      title: 'Faktúry',
    },
    customerProfileInvoicesAndCreditNotesPage: {
      filter: {
        number: 'Číslo faktúry alebo dobropisu',
      },
      title: 'Faktúry a dobropisy',
    },
    customerProfileOrderDetailPage: {
      dialogTitle: 'Vložiť do košíka nákupný zoznam',
      actions: {
        import: 'Vložiť do košíka',
        rename: 'Premenovať',
      },
      phase: {
        label: 'Stav',
      },
      subjectList: {
        title: 'Položky objednávky',
      },
      totalWithTax: {
        label: 'Spolu s DPH',
      },
    },
    customerProfileOrdersConfirmationPage: {
      pageTitle: 'Objednávky na schválenie',
      title: 'Na schválenie/Zamietnutie',
    },
    customerProfileOrdersPage: {
      addUndeliveredItemsToCart: 'Pridať nedodané položky do košíka',
      areYouSureToAddUndeliveredItems: 'Naozaj chcete pridať nedodané položky z objednávky do košíka?',
      title: 'Objednávky',
      orderNotFound: 'Objednávka sa nenašla',
      notAllowed: 'Nemáte oprávnenie na zobrazenie tejto objednávky',
    },
    customerProfilePage: {
      allBranchesLoaded: 'Boli zobrazené všetky pobočky.',
      branchesUsers: 'Pobočky',
      addNewBranch: 'Vložiť novú pobočku',
      newBranch: {
        popupTitle: 'Žiadosť o novú pobočku',
        success: `Vážený zákazník, vaša žiadosť o zavedenie novej dodacej adresy bola úspešne odoslaná do spoločnosti ${projectNameUpperCase}, a.s. na schválenie a zavedenie.`,
        error: 'Došlo k chybe pri spracovaní žiadosti o novú pobočku.',
      },
      changeData: {
        dialogTitle: 'Zmena údajov',
        label: 'Zmeniť údaje',
        mainContact: 'Hlavné oddelenie',
        messages: {
          error: 'Došlo k chybe pri zmene údajov',
          success: 'Zmena údajov prebehla úspešne',
        },
        requestReload: {
          title: 'Zmena hlavnej pobočky používateľa',
          message:
            'Zmena hlavnej pobočky používateľa prebehla úspešne. Pre úplné zobrazenie zmien je potrebné znova načítať stránku. Želáte si stránku znova načítať?',
        },
      },
      changeSubsidiary: {
        dialogTitle: 'Zmena limitov pobočky',
        label: 'Zmeniť limity pobočky',
        messages: {
          formValidation: {
            supervisor: 'Vyberte prosím vedúceho pobočky',
            limit: 'Limit pobočky musí byť číslo väčšie ako 0',
          },
          upsertTotalOrderLimit: {
            error: 'Došlo k chybe pri zmene limitov pobočky',
            success: 'Zmena limitov pobočky prebehla úspešne',
          },
          removeTotalOrderLimit: {
            error: 'Došlo k chybe pri odstránení limitov pobočky',
            success: 'Zrušenie limitov pobočky prebehlo úspešne',
          },
        },
      },
      updatePhone: {
        dialogTitle: 'Zmena telefónneho čísla',
        requiredDialog: 'Zadajte prosím telefónne číslo',
      },
      changePassword: {
        dialogTitle: 'Zmena hesla',
        confirmPassword: 'Zadané heslá sa nezhodujú',
        label: 'Zmeniť heslo',
        passwordStrongEnough: [
          'Heslo nie je dostatočne silné. ',
          'Heslo musí obsahovať aspoň 8 znakov, z ktorých je aspoň jeden veľké písmeno, malé písmeno a číslo.',
          'Heslo nesmie obsahovať medzery.',
        ],
      },
      contactEmail: 'Kontaktný e-mail (Používateľské meno)',
      createMasterUser: 'Vytvoriť master používateľa',
      createUserBranches: 'Vytvoriť používateľa pobočky',
      customer: 'Zákazník',
      deliveryPlaces: {
        label: 'Priradené miesta určenia:',
      },
      user: 'Používateľ',
      errorLoading: 'Nemôžem zobraziť údaje o spoločnosti',
      fullName: 'Meno a priezvisko',
      loadingError: 'Nemôžem zobraziť informácie o neprihlásenom používateľovi.',
      loadMoreBranches: 'Načítať ďalšie pobočky',
      masterUsers: 'Prístupy',
      summerPromoEvaluation: {
        title: 'SUMMER PROMO 2026 – VYHODNOTENIE',
        subtitle: {
          maxLevel: '🎉 Skvelá práca! Získavate maximálny {multiplicator}× násobok bodov.',
          level: '👏 Gratulujeme! Dosiahli ste {multiplicator}× násobok bodov.',
          noLevel: 'Ďakujeme za vaše letné nákupy!',
        },
        lastYearBase: 'Základ z minulého leta:',
        finalPurchase: 'Váš konečný nákup:',
        valueWithoutTax: '{value} bez DPH',
        levelReached: 'Splnená úroveň:',
        levelReachedValue: '{multiplicator}× VIAC BODOV (+{growthPercent} % obratu)',
        standardLevel: 'Získaný štandardný 1× počet bodov',
        totalCredited: 'Spolu pripísané:',
        credited: 'Pripísané na účet:',
        points: `{
        points, plural,
        =1 {{points} bod}
        =2 {{points} body}
        =3 {{points} body}
        =4 {{points} body}
        other {{points} bodov}
        }`,
        pointsShort: '{points} b',
        standardPoints: 'Štandardné body:',
        extraPoints: 'EXTRA letný bonus:',
        missingForBonus: 'Na získanie bonusového násobku chýbalo:',
        footer: {
          levelReached: 'Extra body boli úspešne pripísané na váš vernostný účet.',
          noLevel: 'Body za nákupy nájdete vo svojom vernostnom prehľade.',
        },
      },
      title: 'Používateľský profil',
    },
    customerProfileShoppingListsPage: {
      title: 'Nákupné zoznamy',
      createShoppingList: 'Vytvorenie nákupného zoznamu',
      shoppingListName: 'Názov nákupného zoznamu',
      shoppingListHelperText: 'Pod zadaným názvom nákupný zoznam nájdete v zozname nákupných zoznamov.',
      shoppingListCreate: 'Bol vytvorený nový nákupný zoznam {name}',
      shoppingListDeleted: 'Nákupný zoznam "{name}" bol zmazaný',
      shoppingListUpdated: 'Nákupný zoznam "{name}" bol aktualizovaný',
    },
    homePage: {
      downloadPriceLists: {
        downloadProblem: 'Nepodarilo sa získať informácie na stiahnutie cenníkov.',
        title: 'Cenníky na stiahnutie',
        waitingMessage: 'Cenníky na stiahnutie budú k dispozícii po ich vygenerovaní.',
      },
      gotoShopping: 'Nakupovať',
      title: 'Úvodná stránka',
      welcomeText: {
        part1: 'Vitajte v obchode pre kaderníckych profesionálov spoločnosti MAXCARE.',
        part2: 'Nie sme len distribútorom – sme vaším partnerom v podnikaní.',
      },
      carousel: {
        showItem: 'Zobraziť snímku {number}',
      },
    },
    invoices: {
      actions: {
        addNewInvoice: 'Pridať novú faktúru',
        all: 'Všetky faktúry',
      },
      invoice: {
        billingAddress: {
          helperText: '',
          helperTextPreview: '',
          label: 'Dodacia adresa',
        },
        deliveryNoteNumber: {
          helperText: '',
          helperTextPreview: '',
          label: 'Číslo dodacieho listu',
        },
        invoiceDate: {
          helperText: '',
          helperTextPreview: '',
          label: 'Dátum vystavenia',
        },
        newEntity: 'Nová faktúra',
        number: {
          helperText: '',
          helperTextPreview: '',
          label: 'Číslo',
        },
        orderNumber: {
          helperText: '',
          helperTextPreview: '',
          label: 'Číslo požiadavky',
        },
        paid: {
          helperText: '',
          helperTextPreview: '',
          label: 'Uhradená',
        },
        total: {
          helperText: '',
          helperTextPreview: '',
          label: 'Spolu',
        },
        totalWithTax: {
          helperText: '',
          helperTextPreview: '',
          label: 'Spolu s DPH',
        },
      },
      listPage: {
        table: {
          columns: {
            billingAddress: 'Dodacia adresa',
            download: 'Stiahnuť',
            downloadWithEan: 'Stiahnuť s EAN',
            dueDate: 'Dátum splatnosti',
            invoiceDate: 'Dátum vystavenia',
            number: 'Číslo',
            orderNumber: 'Číslo požiadavky',
            total: 'Spolu',
            totalWithTax: 'Spolu s DPH',
            unpaidAmount: 'Neuhradená čiastka',
          },
          filter: {
            number: 'Číslo',
          },
        },
        title: 'Faktúry',
      },
      scoringBlog: {
        invoiceRowsBlogPreview: {
          columns: {
            priceUnit: 'Cena/ks',
          },
          title: 'Riadky faktúry',
        },
      },
    },
    loginPage: {
      advantageHeading: 'Efektívne riešenie firemných nákupov',
      bullets: {
        bullet1: 'Trojfázový schvaľovací systém',
        bullet2: 'Objednávky podľa kódu produktu',
        bullet3: 'Vytváranie nákupných zoznamov',
        bullet4: 'Správa osôb a stredísk',
        bullet5: 'Prepojenie s naším ERP systémom',
      },
      clothingBranding: 'Branding odevov',
      contact: {
        name: 'Pavel Nešetřil',
        role: 'prevádzkový manažér',
      },
      customerSupport: 'Zákaznícka podpora',
      discountedTransport: 'Zvýhodnená doprava',
      enterYourEmail: 'Zadajte svoj prihlasovací e-mail',
      forgotPassword: 'Zabudnuté heslo',
      individualPrices: 'Individuálne ceny',
      info: 'Moderný obchodník pracujúci 24 hodín denne, ktorý umožňuje nastaviť individuálne B2B prostredie a to od cien až po schvaľovací systém objednávok',
      login: 'Prihlásiť',
      twoWordsLogin: 'Prihlásiť sa',
      loginError: 'Chyba prihlásenia.',
      messages: {
        errorUpdatingPassword: 'Nepodarilo sa obnoviť heslo.',
        passwordSent: 'Heslo bolo odoslané na Váš e-mail {email}.',
      },
      register: 'Registrovať',
      toCreateAccount: 'Pre založenie B2B účtu nás kontaktujte',
      wrongCredentials: 'Nesprávne meno alebo heslo.',
    },
    loginPageRegistration: {
      registrationTitle: 'Registrácia nového zákazníka',
      companyName: 'Názov firmy',
      regNo: 'IČO',
      taxNo: 'DIČ',
      address: 'Ulica',
      city: 'Mesto',
      zipCode: 'PSČ',
      country: 'Krajina',
      website: 'Adresa webových stránok',
      optional: 'nepovinné',
      contactPersonName: 'Meno kontaktnej osoby',
      contactPersonPhone: 'Telefón kontaktnej osoby',
      contactPersonEmail: 'E-mail kontaktnej osoby',
      note: 'Poznámka',
      houseNumber1: 'Súpisné číslo',
      houseNumber2: 'Orientačné číslo',
      cancel: 'Zrušiť',
      sendRegistration: 'Odoslať registráciu',
      close: 'Zavrieť',
      errors: {
        invalidCountryInTaxNo: 'Zadaný štát sa nezhoduje s označením štátu v zadanom DIČ',
        invalidTaxNoPattern:
          'Zadané DIČ nie je v správnom formáte, očakávaný formát predstavuje dve veľké písmená a 8-10 číslic',
      },
      responses: {
        alreadyExists: 'Zákazník so zadanými údajmi v systéme už existuje',
        success: 'Registrácia bola úspešne odoslaná',
        error:
          'Registráciu novej spoločnosti sa bohužiaľ nepodarilo dokončiť. Prosím zopakujte proces, prípadne kontaktujte našu podporu.',
      },
    },
    logoutPage: {
      logoutError: 'Pri odhlasovaní došlo k chybe!',
      logoutInProgress: 'Prebieha odhlásenie',
    },
    mainNavigation: {
      aboutUs: 'O nás',
      usefulInformation: 'Užitočné informácie',
      allAboutShopping: 'Informácie o nákupe',
      allProducts: 'Všetky produkty',
      allRightsReserved: 'Všetky práva vyhradené',
      bulkPurchase: 'Hromadné vloženie',
      downloadDocuments: 'Dokumenty na stiahnutie',
      home: 'Domov',
      introduction: 'Úvod',
      infoDetailDescription: 'Napísať nám môžete kedykoľvek',
      products: 'Tovar',
      ecatalogue: 'E-katalóg',
      store: 'Obchod',
      tos: 'Obchodné podmienky',
      contacts: 'Kontakty',
      download: 'Na stiahnutie',
      gdpr: 'Podmienky ochrany osobných údajov',
      registrationForPartners: 'Registrácia pre partnerov',
    },
    notFoundPage: {
      text: 'Stránka sa nenašla',
    },
    orderDisapprovalPage: {
      dialogTitle: 'Zamietnutie objednávky',
      reason: {
        helperText: 'Dôvod dostane autor objednávky',
        label: 'Dôvod na zamietnutie objednávky',
      },
      title: 'Informácia o zamietnutí objednávky bola odoslaná',
      toCatalogue: 'Prejsť do katalógu',
      toOrders: 'Prejsť na objednávky',
    },
    orders: {
      listPage: {
        table: {
          columns: {
            applicant: 'Žiadateľ',
            dateOfOrder: 'Dátum objednania',
            // download: 'Download',
            owner: 'Vlastník',
            // state: 'State',
            // total: 'Total w/o VAT',
            totalWithTax: 'Spolu',
          },
        },
      },
      order: {
        dateOfOrder: {
          label: 'Dátum objednania',
        },
        externalOrderNumber: {
          label: 'Vaše číslo požiadavky',
        },
        priceLimit: 'Limit ceny objednávky',
      },
    },
    orderSentToApprovalPage: {
      pageTitle: 'Objednávka bola odoslaná na schválenie',
    },
    orderThankYouPage: {
      description: 'Nižšie nájdete informácie k svojej objednávke.',
      notFromOrder: 'Neprichádzate z procesu objednania...',
      pageTitle: 'Ďakujeme za vašu objednávku',
    },
    productDetailPage: {
      details: 'Podrobnosti',
      documents: 'Dokumenty',
      displayError: 'Chyba zobrazenia detailu produktu...',
      notAvailable: 'Tento produkt už nie je v ponuke',
      limited: 'Na túto položku sa vzťahujú reštrikcie na obmedzenie predaja.',
      productQuestsion: 'Otázka k produktu',
      question: 'Otázka',
      replacements: 'Nahrádzajúce produkty',
      alternativesNotFound: 'Momentálne nie sú k dispozícii žiadne alternatívne produkty.',
    },
    productPage: {
      minOrderableQuantity: 'Min.Obj.Mn.',
      parameters: 'Parametre',
      pcsInStock: 'kusov na sklade',
    },
    reactMuiTables: {
      filter: {
        actions: {
          resetFilter: 'resetovať filter',
        },
      },
    },
    shoppingCart: {
      giftsForChoose: {
        modalTitle:
          'Vyberte si {qty, plural, one {{qty} darček z ponuky} few {až {qty} ks darčekov z ponuky} other {až {qty} ks darčekov z ponuky}}',
        modalOpenButton: 'Vyberte si {qty, plural, one {{qty} darček} few {až {qty} ks darčekov} other {až {qty} ks darčekov}}',
        modalAgreeButton: 'Potvrdiť výber darčekov',
      },
      empty: 'Váš košík je prázdný',
      created: 'Bol vytvorený prázdny košík',
      continueInCreated: 'Pokračujete v rozpracovanom košíku',
      messages: {
        cartManipulations: {
          allRemoved: 'Všetky položky košíka boli odstránené.',
          itemAdded:
            '{number, plural, one {Do košíka bola pridaná položka.} few {Do košíka boli pridané {number} položky.} other {Do košíka bolo pridaných {number} položiek.}}',
          itemRemoved:
            '{number, plural, one {Z košíka bola odstránená položka.} few {Z košíka boli odstránené {number} položky.} other {Z košíka bolo odstránených {number} položiek.}}',
          itemCannotBeAdded: 'Položku nie je možné pridať do košíka. Položka bola vyradená z ponuky.',
          itemsReductionByValidation: {
            default:
              'Upozornenie: Niektoré produkty nebolo možné pridať do košíka kvôli ich vyradeniu z ponuky alebo nedostatočnej dostupnosti.',
            one: 'Upozornenie: 1 produkt nebolo možné pridať do košíka kvôli jeho vyradeniu z ponuky alebo nedostatočnej dostupnosti.',
            few: 'Upozornenie: {number} produkty nebolo možné pridať do košíka kvôli ich vyradeniu z ponuky alebo nedostatočnej dostupnosti.',
            many: 'Upozornenie: {number} produktov nebolo možné pridať do košíka kvôli ich vyradeniu z ponuky alebo nedostatočnej dostupnosti.',
          },
        },
      },
      order: 'Objednať',
      quantityField: {
        quantityRounded: 'Množstvo bolo zaokrúhlené na najbližšiu veľkosť balenia s ohľadom na skladovú dostupnosť.',
      },
      replacingProduct: 'Nahradenie produktu',
    },
  },
};

export default skMessages;
